<template>
  <section>
    <gs-header title="Check service ghn"> </gs-header>
    <div class="padding-sm-all">
      <el-form :model="filters" :rules="rules" ref="checkServiceGhn" label-width="200px" label-position="top"
        @submit.prevent.native="validateBeforeSubmit('checkServiceGhn')">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="11">
            <el-form-item label="TP/Quận huyện" prop="city_from_code">
              <el-col :span="24">
                <el-select @change="getDistrictFrom" class="display-block" v-model="filters.city_from_code" filterable
                  placeholder="Chọn tỉnh thành đi">
                  <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.code">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item prop="district_from_code">
              <el-col :span="24" class="margin-sm-top">
                <el-select class="display-block" v-model="filters.district_from_code" filterable
                  placeholder="Chọn quận huyện đi">
                  <el-option v-for="district in districtFrom" :key="district.id"
                    :label="`${district.name} (${district.kind_from_txt})`" :value="district.code">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="text-center">
            <el-tooltip placement="top" content="Đổi bộ lọc" class="display-inline">
              <button :disabled="!filters.district_from_code ||
                !filters.district_to_code ||
                !filters.city_to_code ||
                !filters.city_from_code
                " type="button" class="ui icon button tiny blue" style="margin-top: 50px">
                <i @click="reverseFilter" class="fa fa-arrows-h fa-2x" aria-hidden="true"></i>
              </button>
            </el-tooltip>
          </el-col>
          <el-col :span="11">
            <el-form-item label="TP/Quận huyện" prop="city_to_code">
              <el-col :span="24">
                <el-select @change="getDistrictTo" class="display-block" v-model="filters.city_to_code" filterable
                  placeholder="Chọn tỉnh thành đến">
                  <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.code">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item prop="district_to_code">
              <el-col :span="24" class="margin-sm-top">
                <el-select class="display-block" v-model="filters.district_to_code" filterable
                  placeholder="Chọn quận huyện đến">
                  <el-option v-for="district in districtTo" :key="district.id"
                    :label="`${district.name} (${district.kind_from_txt})`" :value="district.code">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <button class="ui blue basic small button" native-type="submit">
              check
            </button>
          </el-col>
        </el-row>
        <el-row class="remove-margin margin-top">
          <el-col :span="24" v-if="supports.length">
            <el-table :data="supports" border style="width: 100%">
              >
              <el-table-column prop="short_name" label="Name">
              </el-table-column>
              <el-table-column prop="service_id" label="service_id">
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" class="text-red text-center">
            {{ supports.ErrorMessage }}
          </el-col>
        </el-row>
      </el-form>

      <el-row>
        <el-col :span="24">
          <h1 class="text-center">Tra cứu mã địa điểm</h1>
        </el-col>
        <el-table :data="ghnCities" border style="width: 100%">
          >
          <el-table-column prop="ProvinceID" label="Id"> </el-table-column>
          <el-table-column prop="ProvinceName" label="Name"> </el-table-column>
          <el-table-column label="Action">
            <template slot-scope="scope">
              <el-button @click="getGhnDistricts(scope.row)">Quận huyện
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <el-dialog title="quận huyện" :visible.sync="dialogDistricts">
        <el-table :data="ghnDistricts" border style="width: 100%">
          >
          <el-table-column prop="DistrictID" label="Id"> </el-table-column>
          <el-table-column prop="DistrictName" label="Name"> </el-table-column>
          <el-table-column label="Action">
            <template slot-scope="scope">
              <el-button @click="getGhnWards(scope.row)">Phường xã </el-button>
            </template>
          </el-table-column>
        </el-table>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">Cancel</el-button>
        </span>
      </el-dialog>

      <el-dialog title="phường xã" :visible.sync="dialogWards">
        <el-table :data="ghnWards" border style="width: 100%">
          >
          <el-table-column prop="WardCode" label="Id"> </el-table-column>
          <el-table-column prop="WardName" label="Name"> </el-table-column>
        </el-table>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">Cancel</el-button>
        </span>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getGhnServiceSupport, getCarierLocation } from 'src/api/checkService'
export default {
  name: 'CheckServiceGhn',
  data() {
    return {
      supports: {
        Services: [],
      },
      ghnCities: [],
      dialogDistricts: false,
      ghnDistricts: [],
      dialogWards: false,
      ghnWards: [],
      filters: {
        district_from_code: '',
        district_to_code: '',
        city_to_code: '',
        city_from_code: '',
      },
      rules: {
        district_from_code: [
          {
            required: true,
            message: 'Quận huyện đi không được để trống',
            trigger: 'change',
          },
        ],
        district_to_code: [
          {
            required: true,
            message: 'Quận huyện đến không được để trống',
            trigger: 'change',
          },
        ],
        city_to_code: [
          {
            required: true,
            message: 'Tỉnh thành đi không được để trống',
            trigger: 'change',
          },
        ],
        city_from_code: [
          {
            required: true,
            message: 'Tỉnh thành đến không được để trống',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapGetters('city', ['cities']),
    ...mapGetters('district', ['districtTo', 'districtFrom']),
  },
  methods: {
    ...mapActions('city', ['getAllCity']),
    ...mapActions('district', ['getAllDistrictTo', 'getAllDistrictFrom']),
    getDistrictTo() {
      this.filters.district_to_code = ''
      this.getAllDistrictTo({
        city_code: this.filters.city_to_code,
        limit: -1,
        sort: 'name:1',
      })
    },
    getDistrictFrom() {
      this.filters.district_from_code = ''
      this.getAllDistrictFrom({
        city_code: this.filters.city_from_code,
        limit: -1,
        sort: 'name:1',
      })
    },
    validateBeforeSubmit() {
      this.$refs['checkServiceGhn'].validate((valid) => {
        if (valid) {
          this.toggleLoadding()
          getGhnServiceSupport(this.filters).then((response) => {
            this.supports = response.data
            this.toggleLoadding(false)
          })
        } else {
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning',
          })
          return false
        }
      })
    },
    reverseFilter() {
      let oldFilter = Object.assign({}, this.filters)

      this.filters.city_from_code = oldFilter.city_to_code
      this.filters.city_to_code = oldFilter.city_from_code

      this.getDistrictTo()
      this.getDistrictFrom()

      this.$nextTick(() => {
        this.filters.district_from_code = oldFilter.district_to_code
        this.filters.district_to_code = oldFilter.district_from_code

        setTimeout(() => {
          this.validateBeforeSubmit()
        }, 200)
      })
    },
    getGhnCities() {
      getCarierLocation({
        carrier: 'GHNV3',
        action: 'getCities',
        params: [],
      }).then((response) => {
        this.ghnCities = response.data
      })
    },
    getGhnDistricts(ghnCity) {
      getCarierLocation({
        carrier: 'GHNV3',
        action: 'getDistricts',
        params: { province_id: ghnCity.ProvinceID },
      }).then((response) => {
        this.ghnDistricts = response.data
        this.dialogDistricts = true
      })
    },
    getGhnWards(ghnDistrict) {
      getCarierLocation({
        carrier: 'GHNV3',
        action: 'getWards',
        params: { district_id: ghnDistrict.DistrictID },
      }).then((response) => {
        this.ghnWards = response.data
        this.dialogWards = true
      })
    },
  },
  mounted() {
    this.getGhnCities()
    if (!this.cities.length) {
      this.getAllCity({ limit: -1, sort: 'name:1' })
    }
  },
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// CheckServiceGhn.vue?858d92fa